import { BrowserRouter, Routes, Route } from "react-router-dom";
import DeleteAccount from "./components/DeleteAccount";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<DeleteAccount />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
